module.exports = __webpack_public_path__ + "static/fonts/iconfont.ed723a8.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/iconfont.eot?t=1585034858718
// module id = 215
// module chunks = 8